import { render, staticRenderFns } from "./copyForSetting.vue?vue&type=template&id=42501cfc&scoped=true&"
import script from "./copyForSetting.vue?vue&type=script&lang=js&"
export * from "./copyForSetting.vue?vue&type=script&lang=js&"
import style0 from "./copyForSetting.vue?vue&type=style&index=0&id=42501cfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42501cfc",
  null
  
)

export default component.exports